import { createSpotlight } from '@mantine/spotlight';

// Module-level singleton so the patient spotlight can be opened from any entry
// point (header link, hotkeys, etc.) while the modal body is mounted once.
export const [patientSpotlightStore, patientSpotlightUtils] = createSpotlight();

export const openPatientSpotlight = (): void => patientSpotlightUtils.open();
